export default {
  hkStock: '港股',
  usStock: '美股',
  futures: '期货',
  toDeposit: '去入金',
  quotesTitle: '实时行情',
  quotesApply: '行情申请',
  applyRecords: '申请记录',
  domestic: '是',
  unDomestic: '否',
  quotesDomestic: '本人确认本人之所有资料与开户时所提交的资料相同',
  quotestips: '根据Nasdaq的要求，客户在申请使用美股实时行情时，需要提供相关信息以供审核',
  employmentSelector: {
    Employment: '就业',
    selfCare: '自雇',
    retirement: '退休',
    Unemployed: '无业'
  },
  employmentTransfor: {
    '就业': 'employed',
    '自雇': 'self',
    '退休': 'retired',
    '无业': 'unemployed'
  },
  formList: {
    employment: '就业情况',
    company: '公司名称',
    companyAddress: '公司地址',
    industry: '行业/职业',
    occupation: '职业/职务',
    residentialAddress: '住宅地址',
    residentialAddressImg: '住址证明'
  },
  formError: {
    residentialAddress: '请输入住宅地址',
    company: '请输入公司名称',
    companyAddress: '请输入公司地址',
    industry: '请输入行业/职业',
    occupation: '请输入职业/职务',
    imageKeys: '请上传住址证明',
    agreeError: '至少勾选一项',
    employmentSituationContent: '请选择就业情况'
  },
  addressTips: {
    tips: '温馨提示',
    line1: '1、拍照时请将证明文件平放，保持光照充足并避免反光；',
    line2: '2、请确保证明文件上的姓名、日期、住址等信息清晰可见，确保证明文件在最近三个月内；',
    line3: '3、证明文件可以是水电煤、电信、宽带等的增值税发票;或者经执业会计师、律师或公证人认证的信用卡对账单、水电、煤气、电信通知单等。'
  },
  orderId: '订单编号',
  accountNo: '账号',
  applyService: '申请服务',
  updatedTime: '更新时间',
  nextStep: '下一步',
  cancelApplyTitle: '取消行情须知',
  cancelApplyData: `1. 撤销行情申请会于提交申请日的下一个历月开始生效。</br>
  如：1月15日申请撤销，行情有效期会至该月底（即1月31日）。行情会于2月1 日起取消。</br>
  2. 已付的月费不会退还。如：1月15日成功申请终止服务，已缴付之1月份费用不会退还。</br>
  3. 处理申请时间需要一至两个工作天，于该月二十五日或之前提交的申请可于该月完成撤销；于该月二十五日后提交的申请，未必能于该月完成撤销申请，客户有可能需缴付下一历月的行情月费（如有）。</br>
  4. 撤销行情申请后，如需重新开通，需于完成撤销后下一历月重新申请。`,
  conditionTitle: '申请行情须知',
  hkFeaturesTerms: {
    title: '香港期货实时行情条款及条件与声明',
    subTitle: '本人确认清楚明白及签署以同意上述有关申请网上实时报价服务之条款及细则，以及陈述。',
    item: `客户确认清楚明白及签署以同意下述有关申请香港期货实时报价服务之条款及细则，以及下列陈述，您点击同意、接受或下一步，或您登录、或透过本公司进行以下交易所行情订阅的行为均视为您已阅读、理解并同意签署本协议：</br></br>
    1. 费用将于申请审批后实时扣除当月费用；其后于每月25日扣除下个月的费用。</br>
    2. 客户必须确保期货户口内须有足够资金余额以扣除实时报价月费。本公司有权收取客户因户口负数衍生之利息。</br>
    3. 为免引起任何误解, 服务不足一个月亦作一个月计算。本公司有可能会根据交易所收费调整、本服务的整体规划，对本服务的收费标准、方式等进行修改和变更，前述修改、变更，本公司将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等资讯。</br>
    4. 客户确认所有实时报价服务仅供个人使用，不得因任何理由而将任何资料提供予其他人士。</br>
    5. 鉴于资料传输可能受各种不确定因素影响，本公司及相关机构竭力提供准确而可靠的资料，但并不保证资料绝对无误。以上公司等概不负责任何资料错漏、资料传送时差或任何因依赖有关服务导致客户获取之实时报价而蒙受之损失。</br>
    6. 客户充分理解并接受：本公司对因任何原因造成的资讯异常或资讯传递异常情况所致后果不承担责任。</br>
    7. 对市场资料的产权</br>
      (a)客户了解并且同意：(a)交易所对期货资讯享有排他性权益；(b)未经交易所授权许可，任何单位和个人不得从事任何与交易所期货资讯有关的资讯服务业务，包括但不限于发布、经营、增值开发或者传播交易所期货资讯等；(c)除本条款及条件约定外，客户以及任何其他单位或者个人均不享有与交易所期货资讯有关的任何权利（包括但不限于获取、接收、储存或者传播期货资讯的权利）。</br>
      (b)客户了解并同意：行情资料的披露，或者任何违反或威胁违反本条款及条件所包含之承诺与行为，将导致所有交易所蒙受无可挽回的、无法用赔偿金弥补的巨大损失。因此，客户进一步承认并同意：所有相关交易所有权因违反或威胁违反本条款及条件所含任何条款、要求或承诺（包括但不限于：披露或威胁披露行情资讯）的行为，在所有可得法定救济或等价补偿之外，获得履约赔偿、强制救济及其它同等救济。</br>
    8. 客户接收行情资料</br>
    本条款及条件规定了客户接收和使用交易所行情资料的具体条款。客户承认：尽管已经签署了此类协议，每个交易所仍然可以凭其独立裁量权，终止提供其行情资料，或变更或消除其资料传输方式、速度或信号特征。另外，客户承认并同意：所有交易所均保留拒绝任何客户的权利，并且，保留根据任何理由，或在无任何理由的情况下，指示服务商终止某个客户的行情资讯接受权的权利。在此类情况下，交易所应通知服务商此类资讯，而服务商应在现实条件允许的情况下尽快停止行情资讯的提供。</br>
    9. 艾德保留日后更改以上计划及服务之权利及收费，恕不另行通知。</br>
    10. 投资于金融市场具一定风险，投资价格可升可跌。</br>
    `
  },
  eddidPro: {
    title: '香港及环球期货实时行情数据订阅协议',
    subTitle: '本人确认清楚明白及签署以同意上述有关申请网上实时报价服务之条款及细则，以及陈述。',
    item: `一、香港期货实时行情条款及条件与声明</br></br>

    客户确认清楚明白及签署以同意下述有关申请香港期货实时报价服务之条款及细则，以及下列陈述，您点击同意、接受或下一步，或您登录、或透过本公司进行以下交易所行情订阅的行为均视为您已阅读、理解并同意签署本协议：</br></br>
    1.费用将于申请审批后实时扣除当月费用；其后于每月25日扣除下个月的费用。</br>
    2.客户必须确保期货户口内须有足够资金余额以扣除实时报价月费。本公司有权收取客户因户口负数衍生之利息。</br>
    3.为免引起任何误解, 服务不足一个月亦作一个月计算。本公司有可能会根据交易所收费调整、本服务的整体规划，对本服务的收费标准、方式等进行修改和变更，前述修改、变更，本公司将在相应服务页面进行展示。您若需要获取、使用本服务，请先提前了解清楚当时关于本服务的收费标准、方式等资讯。</br>
    4.客户确认所有实时报价服务仅供个人使用，不得因任何理由而将任何资料提供予其他人士。</br>
    5.鉴于资料传输可能受各种不确定因素影响，本公司及相关机构竭力提供准确而可靠的资料，但并不保证资料绝对无误。以上公司等概不负责任何资料错漏、资料传送时差或任何因依赖有关服务导致客户获取之实时报价而蒙受之损失。</br>
    6.客户充分理解并接受：本公司对因任何原因造成的资讯异常或资讯传递异常情况所致后果不承担责任。</br>
    7.对市场资料的产权</br>
    (a)客户了解并且同意：(a)交易所对期货资讯享有排他性权益；(b)未经交易所授权许可，任何单位和个人不得从事任何与交易所期货资讯有关的资讯服务业务，包括但不限于发布、经营、增值开发或者传播交易所期货资讯等；(c)除本条款及条件约定外，客户以及任何其他单位或者个人均不享有与交易所期货资讯有关的任何权利（包括但不限于获取、接收、储存或者传播期货资讯的权利）。</br>
    (b)客户了解并同意：行情资料的披露，或者任何违反或威胁违反本条款及条件所包含之承诺与行为，将导致所有交易所蒙受无可挽回的、无法用赔偿金弥补的巨大损失。因此，客户进一步承认并同意：所有相关交易所有权因违反或威胁违反本条款及条件所含任何条款、要求或承诺（包括但不限于：披露或威胁披露行情资讯）的行为，在所有可得法定救济或等价补偿之外，获得履约赔偿、强制救济及其它同等救济。</br>
    8.客户接收行情资料</br>
    本条款及条件规定了客户接收和使用交易所行情资料的具体条款。客户承认：尽管已经签署了此类协议，每个交易所仍然可以凭其独立裁量权，终止提供其行情资料，或变更或消除其资料传输方式、速度或信号特征。另外，客户承认并同意：所有交易所均保留拒绝任何客户的权利，并且，保留根据任何理由，或在无任何理由的情况下，指示服务商终止某个客户的行情资讯接受权的权利。在此类情况下，交易所应通知服务商此类资讯，而服务商应在现实条件允许的情况下尽快停止行情资讯的提供。</br>
    9.艾德保留日后更改以上计划及服务之权利及收费，恕不另行通知。</br>
    10.投资于金融市场具一定风险，投资价格可升可跌。</br>
    11.本人确认清楚明白及签署以同意上述有关申请网上实时报价服务之条款及细则，以及陈述。</br></br></br>
    二、环球期货市场数据订阅协议</br></br>

    条款及条件与声明</br></br>
    1.投资于金融市场具一定风险，投资价格可升可跌。</br></br>
    2.客户若欲终止以上计划，须于一个月前以书面通知本公司，否则使用期不足一个月者，亦须缴付整月服务费用。</br></br>
    3.艾德证券期货有限公司保留日后更改以上计划及服务之权利及收费，恕不另行通知。</br></br>
    4.客户确认清楚明白及同意下述附录II: 市场数据订阅协议。</br></br>
    5.各参与证券交易所或协会宣称其向发布有关数据各方所提供之一切市场数据拥有专有权益。客户 明白，概无一方担保市场数据或任何其他市场资料之及时性、先后次序、准确性或完整性。因艾德证券期货有限公司或任何发布数据一方之任何疏忽行动、不可抗力事件或任何发布数据一方不能合理控制之其他原因而造成之数据、资料、讯息或其传送或交付而出现之偏差、错误、延误、遗漏或干扰，艾德证券期货有限公司或任何发布数据一方均无须负责。</br></br>
    7. 客户确认所有实时报价服务仅供个人使用，不得因任何理由而将任何数据提供予其他人士。</br></br>
    8. 月费将于客户之期货账户内扣除。</br></br>
    9. 客户必须同意本公司将有关资料提交予服务供应商或任何相关之第三方作为身份核实之用。</br></br>
    10. 客户必须确保期货户口内须有足够美金以扣除报价月费。艾德证券期货有限公司有权收取客户因户口负数衍生之利息。</br></br>

    附录 I: 非金融专业人士自我认证</br></br>
    根据用户的资格，用户可能会被收取较低的信息费用。被认定为“非专业”的用户，才可以获得收取较低的用户费用。</br></br>
    非专业是指并包括任何（i）个人及自然人用户，或者（ii）某些小型企业实体（有限责任公司，合伙企业，信托或公司），收取和使用信息（不包括任何场内交易数据） ，在每种情况下受到以下限制：</br></br>

    非专业用户必须:</br>
    1) 有一个活跃的期货交易账户;</br></br>
    2) 是个人，自然人或小型企业实体;</br></br>
    非专业用户不得:</br></br>
    3) 成为任何交易所会员（或持有或租借任何类型的会员资格）;</br></br>
    4) 注册或有资格作为任何股票，商品或期货交易所或合约市场，或与任何金融监管当局一个专业的交易者或投资顾问的资格;</br></br>
    5) 从事券商，银行，投资或金融活动的机构的代表;</br></br>
    非专业用户使用信息必须:</br></br>
    6) 是专为用户的个人或私人使用;</br></br>
    7) 仅限于管理用户的自有资产，而不是以任何身份与任何第三方的任何资产的管理连接使用;</br></br>
    非专业用户获取资料必须只能:</br></br>
    8) 就每一发布商（数据）通过最多两部已被获准取得实时数据和能够送出交易指令至 CME Globex 平台的交易终端。</br></br>
    不符合非专业用户资格的用户，将被认为是专业用户。</br></br>
    即使在本合同中的任何条款下，CME 有权在所有情况下作出最终决定，用户是否作为一个非专业或专业用户的定义。 CME 保留在任何时间修改本政策或终止非专业用户较低的费用权利。</br></br>
    有资格作为非专业用户应该同意及确认其非专业用户身份并递交自我认证声明回发布商。请注意，本声明可能会受到发行商的审查和认可。若用户不再具有作为一个非专业用户的资格，用户必须在合理可行的情况下，尽快通知发布商。</br></br>


    附录 II: 市场数据订阅协议</br></br>

    本市场数据订阅协议（「协议」）于 申请提交当天（「生效日期」）由艾德证券期货有限公司与阁下订立。本协议准许阁下根据本协议的以下条款及条件存取、收取及使用若干市场数据（定义见下文）。协议监管阁下获取及使用市场数据，并构成经销商与订阅用户（各自为经销商及订阅用户，各自为一「订约方」，及统称为「订约方」）之间具法律约束力的协议。</br></br>
    1. 释义</br>
    a. 「装置」指以可阅读、可收听或其他可理解的形式收取、存取或展示市场数据任何设备（固定或可携式）单位。</br></br>
    b. 「交易所」指包括但不限于CME（芝加哥商业交易所）、CBOT（芝加哥期货交易所）、COMEX（纽约商品交易所）、NYMEX（纽约商业交易所）、ICE Futures Canada（ICE 加拿大期货交易所）、ICE Futures、 Europe（ICE 欧洲期货交易所）及ICE Futures US （ICE 美国洲际期货交易所）。</br></br>
    c. 「不可抗力事件」指任何水灾、特殊天气状况、地震或其他天灾、火灾、战争、恐布活动、叛乱、骚乱、劳资纠纷、意外、政府行动、通讯或电力故障，或设备或软件故障。</br></br>
    d. 「人士」指任何自然人、独自经营业务、法团、合伙经营业务、有限责任公司或其他机构。</br></br>
    e. 「市场数据」指已上市及场外买卖的衍生工具合约（包括但不限于掉期及期货）及期权合约或类似的衍生工具的资料及数据以及指数数据和分析数据。市场数据可包括但不限于开市及收市价、价格高位及低位、结算价、现时买入及卖出价、未平仓合约资料、最后卖价、限价、报价要求、固定价格、数据曲线、估计及实际交易量数据、合约规格，以及最新或延迟讯息。就订阅用户在协议下的责任而言，市场数据亦包括向订阅用户传送与市场数据大致相若的资料的该等资料、数据及村料。</br></br>
    f. 「买卖合约」指在上文所列的交易所买卖的合约及由交易所刊发的任何相应指数。</br></br>
    g. 「场外交易市场数据」指与场外交易衍生工具合约有关的市场数据。</br></br>
    2. 于市场数据的专有权利</br></br>
    a. 订阅用户表示明白及同意各交易所于及对其本身的市场数据享有专有及有价的财产权利。该等未在公开领域内出现的市场数据构成交易所享有的有价保密资料、商业秘密及/或所有权权利，并且该等市场数据最少于直至各相关交易所将之放在公开领域或授权将其各自的市场数据放在公开领域为止将一直为各交易所的有价保密资料、商业秘密及/或专属所有权权利，如非订立本协议，订阅用户将无权利或不可存取该等市场数据。某一交易所是否有将其市场数据放在公开领域或授权将其市场数据公开领域，将根据该交易所与经销商之间订立的协议的条款厘定，该协议的描述载于第 3a 节。</br></br>
    b. 订阅用户表示明白及同意披露任何市场数据或任何违反或威胁违反本协议内所载的任何其他契诺或协定，将对交易所造成无法修补的伤害，金钱上的损害赔偿将不足以补偿。因此，订阅用户进一步表示明白及同意交易所将有权在现时可能享有的任何其他法律或衡平法补救以外（及不限于现时可能享有的任何其他法律或衡平法补救），就违反或威胁违反协议的任何条文、要求或契诺（包括但不限于任何披露或威胁披露市场数据）享有特定的履约及禁制命令及其他衡平法济助。</br></br>
    3. 订阅用户收取市场数据</br></br>
    a. 协议载列订阅用户可使用市场数据的条款及条件。订阅用户表示明白，尽管有任何协议，各交易所可按其酌情权，停止发放市场数据或更改或取消其本身的方法、速度或讯息特点。此外，订阅用户表示明白及同意，经销商或交易所保留权利，可因任何理由或在没有理由下不批准任何订阅用户及终止任何订阅用户收取市场数据， 而在该情况下，交易所将知会经销商，而经销商将在实际可行的情况下尽快停止向订阅用户提供市场数据。</br></br>
    b. (i)除下文第3b(iii)节列明者外，订阅用户将只会以市场数据用于本身的内部业务活动（ 内部业务活动将不包括附属公司及联属公司），及将只会在订阅用户不时以书面形式向经销商指明的该等办事处以及地点和装置上使用。 （在紧接本文的前段内所用的「用于本身的内部业务活动」一词，指用于订阅用户的(a)交易，以其本身的名义或为其客户本身的名义；(b)评估，为其本身的内部业务决定；或(c)向客户提供有关衍生工具市场的动向或趋势的意见，但须受本分节下文有关以电话方式向客户披露必要的市场数据及获允许的市场数据的所有限制所规限。</br></br>
    (ii)订阅用户同意，除上文指定者外，其将不会以任何形式提供或以其他方式协助提供或容许提供市场数据或容许以其他方式协助提供市场数据予任何其他人士或任何办事处或地点，亦不会容许任何其他人士直接或间接从该等办事处或地点获取任何市场数据，并将会采取及执行任何政策以合理防止市场数据该等办事处或地点被取走。订阅用户特别地同意，在不限制或改变其于协议的第 7 节或其他章节下的责任前提下，订阅用户不得为下列目的使用或容许其他人士使用任何市场数据：(a)利用市场数据为基础或摘取市场数据以创建数据产品；(b) 厘定或订定任何价格（包括任何结算价格），包括为衍生工具合约、衍生工具合约的期权或在交易所以外的任何交易所上买卖的类似衍生工具厘定或订定任何价格；及(c)将在外部发布、公布或以其他方式使用该等市场数据的任何其他摘取数据工作。订阅用户将受任何交易所不时可能就该等用途指定的任何其他限制约束。订阅用户将竭尽所能确保其合伙人、行政人员、董事、雇员及代理维持唯一控制及实际上管有及独自可透过订阅用户管有的装置存取市场数据。</br></br>
    (iii)尽管有上文第3b(i)及(ii)节所述，订阅用户可在其日常业务过程中偶尔向其各名客户及分行办事处提供数量被限制于足以让订阅用户能够经营其业务所需的市场数据、或获允许的少量市场数据，惟该等市场数据须并不包括任何场外交易市场数据。该等转发市场数据必须严格限制于通过电话通讯方式，当中不得使用电脑化的语音合成或任何其他科技，并且必须与订阅用户或任何其他接收数据的人士的交易活动有关。订阅用户必须告知任何该等接收数据的人士该等数据属专有及保密资料，不得向其他人士或实体披露或发放。订阅用户同意尽一切合理所能确保该等接收数据的人士受协议的条文约束。</br></br>
    c. 倘经销商已同意允许订阅用户透过经销商提供的装置，例如非经销商所能控制的行情资讯源（data feed）以外的方式收取、存取或展示市场数据，订阅用户将竭尽所能确保可使用其他装置、附件或器材，以让第三方可以在不受订阅用户在上文第3b 节下的报告责任约束下存取市场数据。</br></br>
    4. 报告</br></br>
    订阅用户同意尽速向经销商提供交易所要求或需要及合理地与订阅用户收取市场数据有关的任何资料或报告（如适用）。订阅用户进一步同意尽速向经销商提供第 3a 节所指经销商与订阅用户之间协定须提供与订阅用户收取市场数据有关的任何额外资料或报告。</br></br>
    5. 查阅及审核的权利</br></br>
    a. 任何交易所指定的任何人士可于正常办公时间内亲到订阅用户的办事处或地点，以观察市场数据的编制以及审查和查阅任何装置、附件或器材以及订阅用户根据第3b 和4 节须就其收取和使用市场数据而存置任何账册与记录。</br></br>
    b. 如审计中发现订阅用户少报对市场数据的使用量，订阅用户将即时作出调整（包括以月息 1½厘计算的利息），以补偿经销商及交易所。此外，按任何该交易所的选择，订阅用户将须为该交易所负担发现差异的任何审计工作所产生的合理费用，金额按实际应付该交易所的费用的百分之五（5%）或以上计算。</br></br>
    c. 订阅用户须于有关记录所相关的期间后三（3）年存置其向 CME、CBOT、COMEX 及 NYMEX 报告市场数据时所依据的记录及账册。订阅用户须于有关记录所相关的期间后六（6）年存置其向 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S.及 Eurex 报告市场数据时所依据的记录及账目。倘订阅用户未能如上文规定存置该等记录及账目，订阅用户同意向各交易所支付根据任何有关的审计发现任何差异所招致的合理估计费用。</br></br>
    6. 市场数据费用</br></br>
    订阅用户将根据交易所不时公布当时适用的费率表（包括任何及所有适用的联邦、州份或当地税项），为及代表各交易所（视乎适用而定）向经销商支付（除非经销商根据本协议承担订阅用户的付款责任）收取市场数据的权利的应付费用。各交易所的费用可由各交易所不时作出更改，而毋须事先通知订阅用户。</br></br>
    7. 订阅用户的契诺、声明及保证.</br></br>
    a. 订阅用户契诺、声明及保证，其将不会从事分发市场数据的业务，同时，据其作出合理查询后所知，其乃根据本协议下的授权收取市场数据。</br></br>
    b. 订阅用户同意其将不会使用或允许任何其他人士使用市场数据作任何不合法用途。</br></br>
    c. 订阅用户同意其将不会以任何方式使用市场数据以与交易所或经销商竞争，或以任何方式使用市场数据以协助或让第三方与交易所或经销商竞争。</br></br>
    d. 订阅用户同意，根据本协议提供市场数据须受限于订阅用户严格遵守协议的条款，而经销商或交易所继而可（在发出或不发出通知及有或没有理由下）在其判断订阅用户有任何违反或不遵守本协议的条文下终止上述服务。</br></br>
    e. 订阅用户进一步声明及保证(i)其拥有所有必要权力及授权执行及履行协议；(ii)协议为合法、有效、具约束力及可对订阅用户强制执行；(iii)订阅用户执行或履行协议概无违反对订阅用户或交易所具约束力或适用的任何法律、规则、规例或命令或任何协议、文件或文据；及(iv)订阅用户存取及使用市场数据将根据所有适用联邦、州份、当地法律、规例及条约行事。</br></br>
    8. 保证的免责声明</br></br>
    市场数据将（及订阅用户同意市场数据将）按「原来状况」、「可提供的况」基准提供，不附带任何种类的保证。订阅用户同意：经销商及其联属人士；交易所及其联属人士；以及其各自的任何成员、董事、行政人员、雇员或代理，以及交易所的任何授权人，概不就市场数据或其传送、时间性、准确性或完整性，作出任何明示或暗示的声明或保证，包括但不限于对其用于某一特定用途的可销性、质量或合适性或其未被侵权（以及该等因法规或法律上或因任何买卖过程中或商业使用过程中产生者），作出任何暗示性的保证或任何保证。</br>
    9. 责任及损害赔偿的范围</br></br>
    a. 订阅用户同意：经销商及其联属人士；交易所及其联属人士；以及其各自的任何成员、董事、行政人员、雇员或代理及交易所的任何授权人：</br></br>
    (i) 并不担保市场数据的顺序、准确性或完整性，彼等任何一方亦概不就市场数据或其传送过程中的任何延误、不准确、出错或遗漏，或就因订阅用户收取或使用市场数据而招致的任何损害，对订阅用户或任何其他人士负责，不论是否因彼等本身的疏忽、不可抗力事件或任可其他原因导致。</br>
    (ii) 概不就因协议及市场数据而产生或与之有关的任何（直接、间接或因之而起的）损失、责任或其他损害，对订阅用户或任何其他人士或实体负任何责任，包括但不限于：</br></br>
    (a) 地点或市场数据的任何不准确或不完整或其延迟、受到干扰、出错或遗漏；或</br></br>
    (b) 订阅用户、其客户或任何其他实体或其各自的任何联属人士、董事、行政人员、雇员或代理所 作或不作的任何决定或行动。</br></br>
    (c) 损失业务收入、损失利润或任何惩罚性、间接、相应的、特别或类似的损害，不论任何性质、是否根据已订合约、在侵权法下或其他，即使已获告知产生该等损害的可能性。</br></br>
    b. 订阅用户明确表示明白，经销商、交易所及其联属人士并无就协议及市场数据，向订阅用户或任何第三方作出任何保证（明示或暗示的），包括但不限于：(i)就市场数据用于特定用途的时间性、顺序、准确性、完整性、及时性、可销性、质量或合适性作任何保证；或(ii)就订阅用户或任何第三方使用市场数据所得的效果作任何保证。</br></br>
    c. 如上文的免责声明及责任豁免声明或其任何部分被视为无效或失效，经销商、交易所及其各自的联属人士、董事、行政人员、成员、雇员及代理的累计责任，将不会超过实际的损失或损害金额或合计五十元（50.0美元），以较低者为准。</br></br>
    10. 年期及终止</br></br>
    在订阅用户严格遵守本协议的条文的前提下，任何交易所在本协议下提供市场数据将于订阅用户与经销商之间的协议及其任何续约年期内一直维持有效。此外，根据协定，本协议第 2a 及 2b 节所载的条文将于直至本协议终止为止一直生效。</br></br>
    11. 弥偿</br></br>
    订阅用户将就因或由于协议而产生或招致的任何及全部索偿，向经销商及交易所以及其各自的联属人士、董事、行政人员、雇员及代理作出弥偿保证、为其作出抗辩及使其免于因此而受到损害，包括但不限于因订阅用户根据本协议须存置的任何报告或记录的任何不准确或遗漏或订阅用户未能提供或存置或订阅用户延迟提供或存置该等报告或记录所导致的责任、损失或损害（包括但不限于律师费及其他开支）。</br></br>
    12. 其他事项</br></br>
    a. 因 CME、CBOT、COMEX 及 NYMEX 之间的协议所产生的任何诉讼须受伊利诺州的内部法规（及非利益冲突法）监管及按其诠释。订约各方愿受伊利诺州库克县当地的州及联邦法院的专属司法管辖权管辖。因 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S 及订阅用户之间的本协议而产生的任何诉讼须受纽约州的内部法律（及非利益冲突法）监管及按其诠释。</br></br>
    b. 在未经交易所的事先书面同意前（如适用），订阅用户不得将协议的全部或任何部分转授。</br></br>
    c. 订阅用户不得修改或修订协议的条款。</br></br>
    d. 倘协议的条款及条件与关于订阅用户收取及使用市场数据的任何其他协议之间有任何冲突，当以协议的条款及条件为准。如因任何原因协议的一项或以上条文或其部分变得无效，协议的条文或其他部分将一直维持具十足效力及有效。</br></br>
    声明 </br>
    阁下承认上述条款，即同意以下为真确：</br>
    (1)阁下声明有实际权限代订阅者订立本协议；</br>
    (2)阁下已阅读上述条款；</br>
    (3)阁下理解上述条款；</br>
    (4)上述条款将构成任何适用法例或规例所定「文本」；及</br>
    (5)阁下同意遵守本协议上述所有条款</br></br>

    本人已阅读理解并同意遵守本协议上述所有条款。</br>
    `
  },
  featureTerms: {
    title: '环球期货市场数据订阅协议',
    subTitle: '本人已阅读理解并同意遵守本协议上述所有条款。',
    item: `条款及条件与声明</br></br>
    1. 投资于金融市场具一定风险，投资价格可升可跌。 </br></br>
    2. 客户若欲终止以上计划，须于一个月前以书面通知本公司，否则使用期不足一个月者，亦须缴付整月服务费用。 </br></br>
    3. 艾德证券期货有限公司保留日后更改以上计划及服务之权利及收费，恕不另行通知。 </br></br>
    4. 客户确认清楚明白及同意下述附录 II: 市场数据订阅协议。</br></br>
    5. 各参与证券交易所或协会宣称其向发布有关数据各方所提供之一切市场数据拥有专有权益。客户 明白，概无一方担保市场数据或任何其他市场资料之及时性、先后次序、准确性或完整性。因艾德证券期货有限公司或任何发布数据一方之任何疏忽行动、不可抗力事件或任何发布数据一方不能合理控制之其他原因而造成之数据、资料、讯息或其传送或交付而出现之偏差、错误、延误、遗漏或干扰，艾德证券期货有限公司或任何发布数据一方均无须负责。 </br></br>
    6. 艾德证券期货有限公司，芝加哥商品交易所及相关交易所竭力提供准确而可靠的资料，但并不保证资料绝对无误。以上公司等概不负责任何资料错漏、资料传送时差或任何因依赖有关服务导致客户获取之实时报价而蒙受之损失。 </br></br>
    7. 客户确认所有实时报价服务仅供个人使用，不得因任何理由而将任何数据提供予其他人士。 </br></br>
    8. 月费将于客户之期货账户内扣除。 </br></br>
    9. 客户必须同意本公司将有关资料提交予服务供应商或任何相关之第三方作为身份核实之用。 </br></br>
    10. 客户必须确保期货户口内须有足够美金以扣除报价月费。艾德证券期货有限公司有权收取客户因户口负数衍生之利息。 </br></br>

    <h3 style='text-align:center'> 附录 I: 非金融专业人士自我认证</h3></br></br>
    根据用户的资格，用户可能会被收取较低的信息费用。被认定为“非专业”的用户，才可以获得收取较低的用户费用。 </br></br>
    非专业是指并包括任何（i）个人及自然人用户，或者（ii）某些小型企业实体（有限责任公司，合伙企业，信托或公司），收取和使用信息（不包括任何场内交易数据） ，在每种情况下受到以下限制：</br></br>
    非专业用户必须:</br></br>
    1) 有一个活跃的期货交易账户;</br></br>
    2) 是个人，自然人或小型企业实体;</br></br>
    非专业用户不得:</br></br>
    3) 成为任何交易所会员（或持有或租借任何类型的会员资格）;</br></br>
    4) 注册或有资格作为任何股票，商品或期货交易所或合约市场，或与任何金融监管当局一个专业的交易者或投资顾问的资格;</br></br>
    5) 从事券商，银行，投资或金融活动的机构的代表;</br></br>
    非专业用户使用信息必须:</br></br>
    6) 是专为用户的个人或私人使用;</br></br>
    7) 仅限于管理用户的自有资产，而不是以任何身份与任何第三方的任何资产的管理连接使用;</br></br>
    非专业用户获取资料必须只能:</br></br>
    8) 就每一发布商（数据）通过最多两部已被获准取得实时数据和能够送出交易指令至 CME Globex 平台的交易终端。 </br></br>
    不符合非专业用户资格的用户，将被认为是专业用户。 </br></br>
    即使在本合同中的任何条款下，CME 有权在所有情况下作出最终决定，用户是否作为一个非专业或专业用户的定义。 CME 保留在任何时间修改本政策或终止非专业用户较低的费用权利。 </br></br>
    有资格作为非专业用户应该同意及确认其非专业用户身份并递交自我认证声明回发布商。请注意，本声明可能会受到发行商的审查和认可。若用户不再具有作为一个非专业用户的资格，用户必须在合理可行的情况下，尽快通知发布商。 </br></br></br></br>


    <h3 style='text-align:center'>附录 II: 市场数据订阅协议</h3></br></br>

    本市场数据订阅协议（「协议」）于申请提交当天（「生效日期」）由艾德证券期货有限公司与阁下订立。本协议准许阁下根据本协议的以下条款及条件存取、收取及使用若干市场数据（定义见下文）。协议监管阁下获取及使用市场数据，并构成经销商与订阅用户（各自为经销商及订阅用户，各自为一「订约方」，及统称为「订约方」）之间具法律约束力的协议。 </br></br>
    1. 释义</br>
    a. 「装置」指以可阅读、可收听或其他可理解的形式收取、存取或展示市场数据任何设备（固定或可携式）单位。 </br></br>
    b. 「交易所」指包括但不限于CME（芝加哥商业交易所）、CBOT（芝加哥期货交易所）、COMEX（纽约商品交易所）、NYMEX（纽约商业交易所）、ICE Futures Canada（ICE 加拿大期货交易所）、ICE Futures、 Europe（ICE 欧洲期货交易所）及ICE Futures US （ICE 美国洲际期货交易所）。 </br></br>
    c. 「不可抗力事件」指任何水灾、特殊天气状况、地震或其他天灾、火灾、战争、恐布活动、叛乱、骚乱、劳资纠纷、意外、政府行动、通讯或电力故障，或设备或软件故障。 </br></br>
    d. 「人士」指任何自然人、独自经营业务、法团、合伙经营业务、有限责任公司或其他机构。 </br></br>
    e. 「市场数据」指已上市及场外买卖的衍生工具合约（包括但不限于掉期及期货）及期权合约或类似的衍生工具的资料及数据以及指数数据和分析数据。市场数据可包括但不限于开市及收市价、价格高位及低位、结算价、现时买入及卖出价、未平仓合约资料、最后卖价、限价、报价要求、固定价格、数据曲线、估计及实际交易量数据、合约规格，以及最新或延迟讯息。就订阅用户在协议下的责任而言，市场数据亦包括向订阅用户传送与市场数据大致相若的资料的该等资料、数据及村料。 </br></br>
    f. 「买卖合约」指在上文所列的交易所买卖的合约及由交易所刊发的任何相应指数。 </br></br>
    g. 「场外交易市场数据」指与场外交易衍生工具合约有关的市场数据。 </br></br>

    2. 于市场数据的专有权利</br></br>
    a. 订阅用户表示明白及同意各交易所于及对其本身的市场数据享有专有及有价的财产权利。该等未在公开领域内出现的市场数据构成交易所享有的有价保密资料、商业秘密及/或所有权权利，并且该等市场数据最少于直至各相关交易所将之放在公开领域或授权将其各自的市场数据放在公开领域为止将一直为各交易所的有价保密资料、商业秘密及/或专属所有权权利，如非订立本协议，订阅用户将无权利或不可存取该等市场数据。某一交易所是否有将其市场数据放在公开领域或授权将其市场数据公开领域，将根据该交易所与经销商之间订立的协议的条款厘定，该协议的描述载于第 3a 节。 </br></br>
    b. 订阅用户表示明白及同意披露任何市场数据或任何违反或威胁违反本协议内所载的任何其他契诺或协定，将对交易所造成无法修补的伤害，金钱上的损害赔偿将不足以补偿。因此，订阅用户进一步表示明白及同意交易所将有权在现时可能享有的任何其他法律或衡平法补救以外（及不限于现时可能享有的任何其他法律或衡平法补救），就违反或威胁违反协议的任何条文、要求或契诺（包括但不限于任何披露或威胁披露市场数据）享有特定的履约及禁制命令及其他衡平法济助。 </br></br>

    3. 订阅用户收取市场数据</br></br>
    a. 协议载列订阅用户可使用市场数据的条款及条件。订阅用户表示明白，尽管有任何协议，各交易所可按其酌情权，停止发放市场数据或更改或取消其本身的方法、速度或讯息特点。此外，订阅用户表示明白及同意，经销商或交易所保留权利，可因任何理由或在没有理由下不批准任何订阅用户及终止任何订阅用户收取市场数据， 而在该情况下，交易所将知会经销商，而经销商将在实际可行的情况下尽快停止向订阅用户提供市场数据。 </br></br>
    b. (i)除下文第3b(iii)节列明者外，订阅用户将只会以市场数据用于本身的内部业务活动（ 内部业务活动将不包括附属公司及联属公司），及将只会在订阅用户不时以书面形式向经销商指明的该等办事处以及地点和装置上使用。 （在紧接本文的前段内所用的「用于本身的内部业务活动」一词，指用于订阅用户的(a)交易，以其本身的名义或为其客户本身的名义；(b)评估，为其本身的内部业务决定；或(c)向客户提供有关衍生工具市场的动向或趋势的意见，但须受本分节下文有关以电话方式向客户披露必要的市场数据及获允许的市场数据的所有限制所规限。</br></br>

          (ii)订阅用户同意，除上文指定者外，其将不会以任何形式提供或以其他方式协助提供或容许提供市场数据或容许以其他方式协助提供市场数据予任何其他人士或任何办事处或地点，亦不会容许任何其他人士直接或间接从该等办事处或地点获取任何市场数据，并将会采取及执行任何政策以合理防止市场数据该等办事处或地点被取走。订阅用户特别地同意，在不限制或改变其于协议的第 7 节或其他章节下的责任前提下，订阅用户不得为下列目的使用或容许其他人士使用任何市场数据：(a)利用市场数据为基础或摘取市场数据以创建数据产品；(b) 厘定或订定任何价格（包括任何结算价格），包括为衍生工具合约、衍生工具合约的期权或在交易所以外的任何交易所上买卖的类似衍生工具厘定或订定任何价格；及(c)将在外部发布、公布或以其他方式使用该等市场数据的任何其他摘取数据工作。订阅用户将受任何交易所不时可能就该等用途指定的任何其他限制约束。订阅用户将竭尽所能确保其合伙人、行政人员、董事、雇员及代理维持唯一控制及实际上管有及独自可透过订阅用户管有的装置存取市场数据。 </br></br>

          (iii)尽管有上文第3b(i)及(ii)节所述，订阅用户可在其日常业务过程中偶尔向其各名客户及分行办事处提供数量被限制于足以让订阅用户能够经营其业务所需的市场数据、或获允许的少量市场数据，惟该等市场数据须并不包括任何场外交易市场数据。该等转发市场数据必须严格限制于通过电话通讯方式，当中不得使用电脑化的语音合成或任何其他科技，并且必须与订阅用户或任何其他接收数据的人士的交易活动有关。订阅用户必须告知任何该等接收数据的人士该等数据属专有及保密资料，不得向其他人士或实体披露或发放。订阅用户同意尽一切合理所能确保该等接收数据的人士受协议的条文约束。 </br></br>
    c. 倘经销商已同意允许订阅用户透过经销商提供的装置，例如非经销商所能控制的行情资讯源（data feed）以外的方式收取、存取或展示市场数据，订阅用户将竭尽所能确保可使用其他装置、附件或器材，以让第三方可以在不受订阅用户在上文第3b 节下的报告责任约束下存取市场数据。 </br></br>
    4. 报告</br></br>
    订阅用户同意尽速向经销商提供交易所要求或需要及合理地与订阅用户收取市场数据有关的任何资料或报告（如适用）。订阅用户进一步同意尽速向经销商提供第 3a 节所指经销商与订阅用户之间协定须提供与订阅用户收取市场数据有关的任何额外资料或报告。 </br></br>
    5. 查阅及审核的权利</br></br>
    a. 任何交易所指定的任何人士可于正常办公时间内亲到订阅用户的办事处或地点，以观察市场数据的编制以及审查和查阅任何装置、附件或器材以及订阅用户根据第3b 和4 节须就其收取和使用市场数据而存置任何账册与记录。 </br></br>
    b. 如审计中发现订阅用户少报对市场数据的使用量，订阅用户将即时作出调整（包括以月息 1½厘计算的利息），以补偿经销商及交易所。此外，按任何该交易所的选择，订阅用户将须为该交易所负担发现差异的任何审计工作所产生的合理费用，金额按实际应付该交易所的费用的百分之五（5%）或以上计算。 </br></br>
    c. 订阅用户须于有关记录所相关的期间后三（3）年存置其向 CME、CBOT、COMEX 及 NYMEX 报告市场数据时所依据的记录及账册。订阅用户须于有关记录所相关的期间后六（6）年存置其向 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S.及 Eurex 报告市场数据时所依据的记录及账目。倘订阅用户未能如上文规定存置该等记录及账目，订阅用户同意向各交易所支付根据任何有关的审计发现任何差异所招致的合理估计费用。 </br></br>
    6. 市场数据费用</br></br>
    订阅用户将根据交易所不时公布当时适用的费率表（包括任何及所有适用的联邦、州份或当地税项），为及代表各交易所（视乎适用而定）向经销商支付（除非经销商根据本协议承担订阅用户的付款责任）收取市场数据的权利的应付费用。各交易所的费用可由各交易所不时作出更改，而毋须事先通知订阅用户。 </br></br>
    7. 订阅用户的契诺、声明及保证.</br></br>
    a. 订阅用户契诺、声明及保证，其将不会从事分发市场数据的业务，同时，据其作出合理查询后所知，其乃根据本协议下的授权收取市场数据。 </br></br>
    b. 订阅用户同意其将不会使用或允许任何其他人士使用市场数据作任何不合法用途。 </br></br>
    c. 订阅用户同意其将不会以任何方式使用市场数据以与交易所或经销商竞争，或以任何方式使用市场数据以协助或让第三方与交易所或经销商竞争。 </br></br>
    d. 订阅用户同意，根据本协议提供市场数据须受限于订阅用户严格遵守协议的条款，而经销商或交易所继而可（在发出或不发出通知及有或没有理由下）在其判断订阅用户有任何违反或不遵守本协议的条文下终止上述服务。 </br></br>
    e. 订阅用户进一步声明及保证(i)其拥有所有必要权力及授权执行及履行协议；(ii)协议为合法、有效、具约束力及可对订阅用户强制执行；(iii)订阅用户执行或履行协议概无违反对订阅用户或交易所具约束力或适用的任何法律、规则、规例或命令或任何协议、文件或文据；及(iv)订阅用户存取及使用市场数据将根据所有适用联邦、州份、当地法律、规例及条约行事。 </br></br>

    8. 保证的免责声明</br></br>
    市场数据将（及订阅用户同意市场数据将）按「原来状况」、「可提供的况」基准提供，不附带任何种类的保证。订阅用户同意：经销商及其联属人士；交易所及其联属人士；以及其各自的任何成员、董事、行政人员、雇员或代理，以及交易所的任何授权人，概不就市场数据或其传送、时间性、准确性或完整性，作出任何明示或暗示的声明或保证，包括但不限于对其用于某一特定用途的可销性、质量或合适性或其未被侵权（以及该等因法规或法律上或因任何买卖过程中或商业使用过程中产生者），作出任何暗示性的保证或任何保证。 </br></br>
    9. 责任及损害赔偿的范围</br></br>
    a. 订阅用户同意：经销商及其联属人士；交易所及其联属人士；以及其各自的任何成员、董事、行政人员、雇员或代理及交易所的任何授权人：</br></br>
    (i) 并不担保市场数据的顺序、准确性或完整性，彼等任何一方亦概不就市场数据或其传送过程中的任何延误、不准确、出错或遗漏，或就因订阅用户收取或使用市场数据而招致的任何损害，对订阅用户或任何其他人士负责，不论是否因彼等本身的疏忽、不可抗力事件或任可其他原因导致。 </br></br>
    (ii) 概不就因协议及市场数据而产生或与之有关的任何（直接、间接或因之而起的）损失、责任或其他损害，对订阅用户或任何其他人士或实体负任何责任，包括但不限于：</br></br>
    (a) 地点或市场数据的任何不准确或不完整或其延迟、受到干扰、出错或遗漏；或</br></br>
    (b) 订阅用户、其客户或任何其他实体或其各自的任何联属人士、董事、行政人员、雇员或代理所 作或不作的任何决定或行动。 </br></br>
    (c) 损失业务收入、损失利润或任何惩罚性、间接、相应的、特别或类似的损害，不论任何性质、是否根据已订合约、在侵权法下或其他，即使已获告知产生该等损害的可能性。 </br></br>
                  b. 订阅用户明确表示明白，经销商、交易所及其联属人士并无就协议及市场数据，向订阅用户或任何第三方作出任何保证（明示或暗示的），包括但不限于：(i)就市场数据用于特定用途的时间性、顺序、准确性、完整性、及时性、可销性、质量或合适性作任何保证；或(ii)就订阅用户或任何第三方使用市场数据所得的效果作任何保证。 </br></br>
    c. 如上文的免责声明及责任豁免声明或其任何部分被视为无效或失效，经销商、交易所及其各自的联属人士、董事、行政人员、成员、雇员及代理的累计责任，将不会超过实际的损失或损害金额或合计五十元（50.0美元），以较低者为准。 </br></br>
    10. 年期及终止</br></br>
        在订阅用户严格遵守本协议的条文的前提下，任何交易所在本协议下提供市场数据将于订阅用户与经销商之间的协议及其任何续约年期内一直维持有效。此外，根据协定，本协议第 2a 及 2b 节所载的条文将于直至本协议终止为止一直生效。 </br></br>
    11. 弥偿</br></br>
    订阅用户将就因或由于协议而产生或招致的任何及全部索偿，向经销商及交易所以及其各自的联属人士、董事、行政人员、雇员及代理作出弥偿保证、为其作出抗辩及使其免于因此而受到损害，包括但不限于因订阅用户根据本协议须存置的任何报告或记录的任何不准确或遗漏或订阅用户未能提供或存置或订阅用户延迟提供或存置该等报告或记录所导致的责任、损失或损害（包括但不限于律师费及其他开支）。 </br></br>
    12. 其他事项</br></br>
    a. 因 CME、CBOT、COMEX 及 NYMEX 之间的协议所产生的任何诉讼须受伊利诺州的内部法规（及非利益冲突法）监管及按其诠释。订约各方愿受伊利诺州库克县当地的州及联邦法院的专属司法管辖权管辖。因 ICE Futures Canada、ICE Futures Europe、ICE Futures U.S 及订阅用户之间的本协议而产生的任何诉讼须受纽约州的内部法律（及非利益冲突法）监管及按其诠释。 </br></br>
    b. 在未经交易所的事先书面同意前（如适用），订阅用户不得将协议的全部或任何部分转授。 </br></br>
    c. 订阅用户不得修改或修订协议的条款。 </br></br>
    d. 倘协议的条款及条件与关于订阅用户收取及使用市场数据的任何其他协议之间有任何冲突，当以协议的条款及条件为准。如因任何原因协议的一项或以上条文或其部分变得无效，协议的条文或其他部分将一直维持具十足效力及有效。 </br></br>

    声明 </br>
    阁下承认上述条款，即同意以下为真确：</br>
    (1)阁下声明有实际权限代订阅者订立本协议；</br>
    (2)阁下已阅读上述条款；</br>
    (3)阁下理解上述条款；</br>
    (4)上述条款将构成任何适用法例或规例所定「文本」；及</br>
    (5)阁下同意遵守本协议上述所有条款</br>
    `
  },
  stockterms: {
    // 港股,美股
      title: '港股/美股实时行情条款及条件与声明',
      subTitle: '本人确认清楚明白及签署以同意上述有关申请网上即时实时服务之条款及细则，以及陈述。',
      item: `1.费用将于申请审批后实时扣除当月费用；其后于每月25日扣除下个月的费用。</br>
        2.客户必须确保证券户口内须有足够资金余额以扣除报价月费。本公司有权收取客户因户口负数衍生之利息。</br>
        3.为免引起任何误解, 服务不足一个月亦作一个月计算。</br>
        4.客户如若欲终止以上计划，请于每月自动续期扣费前(即每月的第25日前)提出。</br>
        5.客户确认所有实时报价服务仅供个人使用，不得因任何理由而将任何数据提供予其他人士。</br>
        6.客户必须同意本公司将有关资料提交予服务供应商或任何相关之第三方作为身份核实之用。</br>
        7.本公司及相关机构竭力提供准确而可靠的资料，但并不保证资料绝对无误。以上公司等概不负责任何资料错漏、资料传送时差或任何因依赖有关服务导致客户获取之实时报价而蒙受之损失。</br>
        8.各参与证券交易所或协会宣称其向发布有关数据各方所提供之一切市场数据拥有专有权益。客户明白，概无一方担保市场数据或任何其他市场资料之及时性、先后次序、准确性或完整性。因艾德或任何发布数据一方之任何疏忽行动、不可抗力事件或任何发布数据一方不能合理控制之其他原因而造成之数据、资料、讯息或其传送或交付而出现之偏差、错误、延误、遗漏或干扰，艾德或任何发布数据一方均无须负责。</br>
        9.艾德保留日后更改以上计划及服务之权利及收费，恕不另行通知。</br>
        10.投资于金融市场具一定风险，投资价格可升可跌。`
  },
  conditionDialogTitle: '申请行情须知',
  ineligibleDialogTitle: '未符合条件申请',
  ineligibleTipContent: '很抱歉,由于您未在2019年6月1日后成功存入资金,暂不支持申请',
  consentRules: '本人确认清楚明白及签署以上同意上述有关申请网上及时报价服务之条款及细则，以及陈述.',
  submitApply: '确认申请',
  selectQuotesErr: '请选择申请类型',
  applyContentType: {
    'EDDID_FAMILY_BUCKET_MARKET_FREE': '艾德一站通行情-免费',
    'JIELI_GLOBAL_HK_STOCKS_MARKET': '捷利环球港股行情',
    'JIELI_GLOBAL_US_STOCKS_MARKET': '捷利美股行情',
    'EDDID_FAMILY_BUCKET_MARKET': '艾德一站通行情',
    'HK_STOCKS_REAL_TIME_MARKET_FREE': '港股实时行情-免费',
    'HK_STOCKS_REAL_TIME_MARKET': '港股实时行情',
    'US_STOCKS_REAL_TIME_MARKET': '美股实时行情',
    'FUTURES_REAL_TIME_MARKET': '期货实时行情',

    'eddid_family_bucket_market_free': '艾德一站通行情-免费',
    'jieli_global_hk_stocks_market': '捷利环球港股行情',
    'jieli_global_us_stocks_market': '捷利美股行情',
    'eddid_family_bucket_market': '艾德一站通行情',
    'hk_stocks_real_time_market_free': '港股实时行情-免费',
    'hk_stocks_real_time_market': '港股实时行情',
    'us_stocks_real_time_market': '美股实时行情',
    'futures_real_time_market': '期货实时行情'
  },
  status: {
    submitted: '审核中',
    processing: '审核中',
    reject: '失败',
    completed: '已开通',
    notOpen: '未开通',
    SUBMITTED: '审核中',
    PROCESSING: '审核中',
    COMPLETED: '已开通',
    REJECT: '失败',
    IMMEDIATE_APPLY: '立即申请',
    CANCLED: '已取消'
  },
  buttonStatus: {
    IMMEDIATE_APPLY: '立即申请',
    COMPLETED: '取消订阅',
    NO_BUTTON: '审核中'
  },
  NEW: '开通',
  RENEW: '续订',
  CANCEL: '取消',
  noQuotes: '无行情申请记录',
  confirm: '确 定',
  cancel: '取 消',
  cancelSuccess: '已退订',
  hasUsed: '前有效',
  submitText: '立即申请',
  unit: '/月',
  timeUnit: {
    'DAY': '日',
    'WEEK': '周',
    'MONTH': '月',
    'QUARTER': '季',
    'YEAR': '年'
  },
  isCanceled: '已退订',
  conditionDataFirsttext: `1. 现有客户可申请购买`,
  moneyText: '，费用为每月HKD {money}',
  conditionDatalasttext: `。（客户需确保交易账户中有足够的现金余额作每月扣款，才获审批开通)。</br>
    2. 费用将于申请审批后实时扣除当月费用；其后于每月25日扣除下个月的费用；</br>
    3. 费用计算方式</br>
    服务不足一个月亦作一个月计算。如：1月15日申请，当月只剩16天，不够整月，亦按照整月收费。而在1月25日则会扣除整个2月的费用 - HKD `,
  feeContent: '免费',
  feeText: '前有效',
  notProfessionInfo: '（只适用于非金融专业人士申请）',
  stockNotMoneyInfo: '证券账户可用资金不足，请补充入金后重试',
  futuresNotMoneyInfo: '期货账户可用资金不足，请补充入金后重试',
  mixNotMoneyInfo: '可用资金不足，请补充入金后重试',
  usErrorInfo: '请确认本人之所有资料与开户时所提交的资料是否相同',
  fee: '费用明细',
  noAccountInfo: '您当前无状态正常的交易账户，前往查看',
  goto: '前往',
  validityPeriod: '(临时有效期)',
  enterChange: '请填写已有更改的资料',
  eddidProConditiontext: `1.现有期货客户可申请使用{name}，此服务包含香港及环球期货实时行情，服务费用为每月HKD$568（推广期内优惠月费为{currency}\${price}）；</br>
  2.{name}所提供的实时行情服务可于Eddid One PC及手机应用程序（APP）使用；</br>
  3.有关费用将于成功开通后即时扣除；其后于每月25日扣除下个月的费用；</br>
  4.阁下在{name}服务生效后，即表示您授权艾德证券期货根据上列价格每月自动续期，阁下需确保其期货交易账户中有足够的港币或等值货币现金结余作每月扣款之用，以免被暂停服务；</br>
  5.服务使用不足一个月费用亦作一个月计算。如：1月15日申请，当月只剩16天，不够整月，亦会收取整月收费。而在1月25日后申请则会扣除1月及2月的费用。</br>`
}
